<template>
    <jet-authentication-card>
        <template #logo>
            <jet-authentication-card-logo />
        </template>

        <div class="mb-4 text-sm text-iron-600">
            {{ $t("auth.verify.description") }}
        </div>

        <div
            v-if="verificationLinkSent"
            class="mb-4 text-sm font-medium text-green-600"
        >
            {{ $t("auth.verify.link_sent") }}
        </div>

        <div>
            <div class="mt-4 flex items-center justify-between">
                <jet-button
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing"
                    @click="submit"
                    >{{
                        $t("auth.verify.resend_verification_email")
                    }}</jet-button
                >

                <button
                    class="text-sm text-iron-600 underline hover:text-iron-900"
                    @click="logout"
                >
                    {{ $t("auth.verify.log_out") }}
                </button>
            </div>
        </div>
    </jet-authentication-card>
</template>

<script setup lang="ts">
import JetAuthenticationCard from "../../Jetstream/AuthenticationCard.vue";
import JetAuthenticationCardLogo from "../../Jetstream/AuthenticationCardLogo.vue";
import JetButton from "../../Jetstream/Button.vue";
import { computed } from "vue";
import { router, useForm } from "@inertiajs/vue3";
import route from "ziggy-js";

const props = defineProps({
    status: {
        required: false,
        type: String,
    },
});

const form = useForm({});

const submit = function () {
    form.post(route("verification.send"));
};

const verificationLinkSent = computed(function () {
    return props.status === "verification-link-sent";
});

const logout = function () {
    router.post(
        route("logout"),
        {},
        {
            onFinish: () => window.location.replace("https://zaptime.app"),
        },
    );
};
</script>
